<template>
    <split-pane  :min-percent='10' :default-percent='13' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <el-input :placeholder="$LANG('1779', '请输入关键字进行过滤')" v-model="filterText" size="medium"  ></el-input>
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                        default-expand-all     
                        :style="{background:'#fff',overflow:'auto',height: scrollerHeight}"
                        highlight-current
                        v-loading="loadingtree"
                        :element-loading-text="$LANG('1959', '加载中')"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"    
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  >
                        <span  style="color:#409eff;font-size:14px;"><i class="iconfont icon-mokuai1" style="color:#409eff;font-size:18px;"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i> {{ node.label}} 【 {{data.id}} 】 </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR">
            <div class="ve-list-page ve-list-page--embedded ve-list-page--pane">
            <div style=" display:flex; min-width:1150px; background:#fff;line-height:30px;padding-top:3px; border-bottom:2px solid #389;">
                <div style="width:1350px;display:flex; ">
                    <i class="iconfont icon-xitongguanli" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="typeSet" :underline="false" ><span style="font-size:12px;margin-right:15px;font-weight:600">{{ $LANG('0907', '类别设置') }}</span></el-link>
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;font-weight:600">{{ $LANG('0095', '新增记录') }}</span></el-link>
 
                    <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" size="small" style="width:130px;margin-left:10px; ">
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="input_hold" clearable ref="refinput"  v-model="txtparam" @keyup.enter.native="queryEvent('N')" size="small" style="width:300px; height:30px; ">
                        <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent('N')" ></el-button>
                    </el-input>
                    <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                        <el-button type="danger" size="small" style="height:31px">
                            {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown"  >
                            <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                            <el-dropdown-item divided icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
 
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div> 
            <div style="width:100%" class="ve-list-page__body">
                <div class="ve-list-page__table">
                <ve-table :columns="vueCol" 
                        :table-data="tabData" 
                        :columnHiddenOption="columnHiddenOption"
                        style="margin-top:2px; "
                        :border-around="true"
                        :border-x="true" 
                        :border-y="true" 
                        :fixed-header="true"
                        row-key-field-name="IDSEQ"
                        :row-style-option="rowStyleOption"
                        :cell-style-option="cellStyleOption"
                        :max-height="tabHeight" 
                        :virtual-scroll-option="virtualScrollOption"
                        :scroll-width="0"       
                        :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                        :column-width-resize-option="columnWidthResizeOption"
                        :cellSelectionOption="{enable: false,}"
                        id="loading-mat"
                        ref="tableRef" >
                </ve-table>
                </div>
                <div style="margin-top:2px" class="ve-list-page__pagination">
                    <ve-pagination
                        :total="dataCount"
                        :page-index="pageIndex"
                        :page-size="pageSize"
                        :page-size-option="pageList"
                        @on-page-number-change="pageNumberChange"
                        @on-page-size-change="pageSizeChange"
                    />
                </div>
            </div> 
 
                <!-- 编辑表单 -->
                <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
                    </div> 
                    <div style=" overflow-y:auto;height:88vh;">
                        <div style="display:flex; height:42px;font-size:14px;font-weight:700;color:#333;margin-left:5px">  
                            <div  class="oneMenu">
                                <div  :class="{active: v_tabName==='first'}" @click="itemClick('first')">
                                    <i class="iconfont icon-shujuzidian" style="font-size:18px; "></i>
                                    {{ $LANG('0342', '样板') }}{{ $LANG('0395', '资料') }}
                                </div> 
                            </div>
                            <div  class="oneMenu" style="margin-left:30px">
                                <div  :class="{active: v_tabName==='second'}" @click="itemClick('second')">
                                    <i class="iconfont icon-navicon-qghztj" style="font-size:18px; "></i>
                                    {{ $LANG('0342', '样板') }}{{ $LANG('1018', '销售明细') }}
                                </div> 
                            </div>
                            <div  class="oneMenu" style="margin-left:30px">
                                <div  :class="{active: v_tabName==='third'}" @click="itemClick('third')">
                                    <i class="iconfont icon-caigouguanli-" style="font-size:18px; "></i>
                                    {{ $LANG('0342', '样板') }}{{ $LANG('1005', '采购明细') }}
                                </div> 
                            </div>
 
                        </div>
    
                            <div v-if="v_tabName=='first'" style="margin-top:-5px">
                                <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                                    <div class="one-div">
                                        <span class="oneRow">
                                            {{gpitem.gpnm}} <span v-if ="gpitem.gpno==='14375'">：{{ formatAttachmentLimit(6) }}</span>
                                        </span> 
                                    </div>
                                    <Form :model="matRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                                <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="matRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                                <el-select size="medium" filterable v-else-if="item.FLDNO==='CLNTNO'" :disabled="saveFlag" style="width:100%" v-model="matRow[item.FLDNO]">
                                                    <el-row v-for="item in clntArr " :key="item.IDNO">
                                                        <el-col :span="6">
                                                            <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                                        </el-col>
                                                        <el-col :span="6">
                                                            <el-option  :label="item.CLTYPENM" :value="item.IDNO"></el-option>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <el-option  :label="item.CLNTNM" :value="item.IDNO"></el-option>
                                                        </el-col>
                                                    </el-row>
                                                </el-select>
                                                <el-input type="number"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   v-else-if="item.EDCSS=='number'" size="small" v-model="matRow[item.FLDNO]" style="width:100%"> </el-input>
                                                <el-checkbox size="small"  border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="matRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                                <el-select size="small"    clearable :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="matRow[item.FLDNO]"   style="width:100%">
                                                    <el-option v-for="(it,index) in comboArr[item.FLDNO]" :key="index" :label="it.CNAME" :value="it.CODE"></el-option>
                                                </el-select>
                                                <el-input type="number" size="small"  v-else-if="item.FLDNO==='OUTPRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                                    <el-select slot="append"   v-model="matRow['OUTCRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px; ">
                                                        <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                                    </el-select>
                                                </el-input>
                                                <el-input type="number" size="small"  v-else-if="item.FLDNO==='PRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                                    <el-select slot="append"  v-model="matRow['CRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px; ">
                                                        <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                                    </el-select>
                                                </el-input>
                                                <el-input type="text" size="small"  v-else-if="item.key==='MATTYNM'" readonly  v-model="matRow[item.FLDNO]">
                                                    <div slot="append">
                                                        <el-button @click="matChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                                    </div>
                                                </el-input>
                                                <el-input size="small"  :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="matRow[item.FLDNO]"></el-input>
                                            </FormItem>
                                        </span>
                                    </Form>
                                    <!-- 产品参数:14737-->
                                    <span v-if="gpitem.gpno==='14373'"> 
                                        <Form :model="paramRow" :label-width="120" ref="paramWin"  label-position="right" inline >  
                                            <span v-for="(item,index) in paramArr" :key="index" >
                                                <FormItem  :label="item.cname"  class="item-width" :prop="item.code"  >
                                                    <el-input size="small"  :disabled="saveFlag" :placeholder="$LANG('1663', '请输入')" v-if="item.ishand==='Y'" type="text"  @input="modelChange"   v-model="paramRow[item.lstseq]" style="width:100%"></el-input>
                                                    <el-select size="small"  :disabled="saveFlag" :placeholder="$LANG('1664', '请选择')" v-else @change="modelChange" v-model="paramRow[item.lstseq]"  style="width:100%" filterable clearable>
                                                        <el-option v-for="(it,ind) in item.children" :key="ind" :value="it.code" :label="it.cname" ></el-option>
                                                    </el-select> 
                                                </FormItem>
                                            </span>
                                        </Form>
                                    </span>
                                    <!-- 产品图片:14374 -->
                                    <span v-if="gpitem.gpno==='14374'"> 
                                        <div style="display:flex" >
                                            <Upload
                                                ref="upload"
                                                name="upfile"
                                                :data="uploadData"
                                                :show-upload-list="false"
                                                :before-upload="(file) =>beforeImgFile(file,'IMG')"
                                                :on-success="successImgFile"
                                                :with-credentials="true"                            
                                                :format="['jpg','jpeg','png' ]"
                                                :max-size="2048"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize"
                                                type="drag"
                                                :disabled="saveFlag"
                                                :on-progress="handleProgress"
                                                :action="uploadUrl"
                                                style="display: inline-block;width:200px; ">                           
                                                <div style="padding: 1px 0;width:200px;height:150px;" >
                                                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                                    <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                                                </div>                                                       
                                            </Upload> 
                                            <div style="display:flex;margin-left:30px;"  >
                                                <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='IMG')" :key="index">  
                                                    <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                                        <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                                    </div>
                                                    <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                                                    <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                                        <span style="font-weight:600;font-size:12px;color:red"> {{ $LANG('0473', '文件名：') }}</span>{{item.FILENM}}
                                                    </div>
                                                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                                        <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                                                    </div>
                                                </span>
                                            </div> 
                                        </div>
                                    </span>
                                    <!-- 数据手册:14375  -->
                                    <span v-if="gpitem.gpno==='14375'"> 
                                        <div style="display:flex" >
                                            <Upload
                                                name="upfile"
                                                :data="upFile"
                                                :show-upload-list="false"
                                                :before-upload="(file) =>beforeImgFile(file,'DATA')"
                                                :on-success="successImgFile"
                                                :accept="acceptPdf"                           
                                                :max-size="10240"
                                                :with-credentials="true"          
                                                :on-exceeded-size="handleMaxPdf"
                                                :on-progress="handleProgress"
                                                type="drag"
                                                :disabled="saveFlag"
                                                :action="uploadUrl"
                                                style="display: inline-block;width:200px; ">                           
                                                <div  style="padding: 1px 0;width:200px;height:150px; " >
                                                    <el-image :disabled="saveFlag" src="/assets/basedict/nopic.png" style="margin-top:80px;"></el-image> 
                                                    <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                                                </div>                                                       
                                            </Upload> 
 
                                            <div style="display:flex;margin-left:30px;"  >
                                                <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='DATA')" :key="index">  
                                                    <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                                        <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                                    </div>
                                                    <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                                                    <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                                        <span style="font-weight:600;font-size:12px;color:red"> {{ $LANG('0473', '文件名：') }}</span>{{item.FILENM}}
                                                    </div>
                                                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                                        <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                                                    </div>
                                                </span>
                                            </div> 
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div v-if="v_tabName=='second'" style="margin-top:-5px">    
                                <el-table  :data="ordData" 
                                    border        
                                    class="custom-table-border"     
                                    :cell-style="{padding:'2px'}"               
                                    disabled-hover
                                    style="overflow:auto;margin-top:1px;"
                                    size="small"
                                    :height="tabHeight" 
                                    highlight-current-row>
                                <span v-for="(item,index ) in ordArr" :key="index">
                                    <el-table-column  v-if="item.thide==='N'"
                                        :prop="item.key"
                                        :label="item.title"
                                        show-overflow-tooltip
                                        :align="item.align"                                  
                                        sortable
                                        :min-width="item.width">
                                    </el-table-column> 
                                </span>
                                </el-table>
                            </div>
                            <div v-if="v_tabName=='third'" style="margin-top:-5px">
                                
                                <el-table  :data="poData" 
                                    border          
                                    :cell-style="{padding:'2px'}"                  
                                    disabled-hover
                                    class="custom-table-border"
                                    style="overflow:auto;margin-top:1px;"
                                    size="small"
                                    :height="tabHeight" 
                                    highlight-current-row>
                                    <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
                                    <el-table-column  v-for="(item,index ) in poArr.filter(item=>item.thide=='N')" :key="index"
                                        :prop="item.key"
                                        :label="item.title"
                                        show-overflow-tooltip
                                        :align="item.align"                                  
                                        sortable
                                        :min-width="item.width">
                                    </el-table-column> 
                                
                                </el-table>
                            </div>
                  
                    </div>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right" >
                            <el-button :disabled="prevFlag" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">{{ $LANG('0519', '上行记录') }}</el-button>
                            <el-button :disabled="nextFlag" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">{{ $LANG('0525', '下行记录') }}</el-button>
                            <span :style="stfgColor">
                                <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:40px;height:35px;vertical-align:middle"></i>
                            </span>
                            <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                            <el-button :disabled="saveFlag?true:false" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                        </span>
                    </div>
                </el-dialog>
                <!-- 提示框 -->
                <el-dialog v-dialogDrag :show-close="false" :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                    </div>
                    <div style="line-height:30px;display:flex">
                        <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                        <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                    </div>
                    <span slot="footer"  >
                        <el-button type="primary" size="small" @click="promtWin = false">{{ $LANG('1638', '确 定') }}</el-button>
                    </span>
                </el-dialog>
                <!-- 类别属性管理 -->
                <el-dialog v-dialogDrag :show-close="false" :visible.sync="mgtModel"  width="910px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;color:white">{{ $LANG('0041', '所选类目') }}：{{matRow['MATTYNM']}}</span>
                        <el-button @click="addParam()" type="text" size="small" icon="iconfont icon-xinzeng" style="margin-right:20px;float:right;color:white;font-size:14px;white-space:nowrap;"> {{ $LANG('1264', '新增类别属性') }}</el-button>
                    </div> 
                    <el-table  :data="propData" 
                        border                            
                        size="small"
                        ref="proptab"
                        class="custom-table-border"
                        :cell-style="{padding:'2px'}"
                        :height="420" 
                        highlight-current-row
                        style="overflow:auto;margin-top:1px;"> 
                            <el-table-column 
                                prop="LSTSEQ"
                                :label="$LANG('0304', '属性')+'ID'"
                                show-overflow-tooltip
                                align="center"                                  
                                disabled
                                width="80">
                            </el-table-column> 
                            <el-table-column 
                                prop="CNAME"
                                :label="$LANG('0708', '属性名称')"
                                show-overflow-tooltip
                                align="center"                                  
                                sortable
                                width="350">
                            </el-table-column> 
                            <el-table-column  
                                prop="ISHAND"
                                :label="$LANG('0042', '手动输入')"
                                align="center"                                  
                                sortable
                                width="100">
                                <template slot-scope="scope" >
                                    <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row.ISHAND" >&nbsp;</el-checkbox>
                                </template>
                            </el-table-column> 
                            <el-table-column  
                                prop="STFG"
                                :label="$LANG('1946', '启用')"
                                align="center"                                  
                                sortable
                                width="80">
                                <template slot-scope="scope" >
                                    <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row.STFG" >&nbsp;</el-checkbox>
                                </template>
                            </el-table-column> 
                            <el-table-column  
                                prop="SORT"
                                :label="$LANG('0327', '排序')"
                                align="center"                                  
                                sortable
                                width="80">
                                <template slot-scope="scope" >
                                    <el-button size="small" v-if="scope.$index>0"   type="text" icon="el-icon-top" @click="moveUp(scope.row,scope.$index)"></el-button>
                                    <el-button size="small" v-if="scope.$index<propData.length-1"   type="text" icon="el-icon-bottom" @click="moveDown(scope.row,scope.$index)"></el-button>
                                </template>
                            </el-table-column> 
                        <el-table-column
                            fixed="right"
                            :label="$LANG('0330', '操作')"
                            align="center"
                            width="190">
                            <template slot-scope="scope">
                                <el-button style="margin-right:10px;"   type="text" icon="el-icon-edit" @click="modRec(scope.row,scope.$index)">{{ $LANG('1639', '编辑') }}</el-button>
                                <el-button  type="text" icon="el-icon-setting" @click="mgtRec(scope.row,scope.$index)">{{ $LANG('0497', '管理值') }}</el-button>
                            </template>
                        </el-table-column>                       
                    </el-table>
                    <div slot="footer">
                        <span style="color:#2db7f5;font-size:12px;margin-left:10px;float:left">{{ $LANG('0834', '共') }} {{specForm.CNT}} {{ $LANG('0479', '条记录') }} </span>
                        <el-button style="margin-right:50px;" type="text" icon="iconfont icon-shanchu" @click="mgtModel=false">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="text" style="margin-right:10px;" icon="iconfont icon-baocun" @click="mgtSave">{{ $LANG('0130', '保存') }}</el-button>
                    </div>
                </el-dialog>
                <el-dialog v-dialogDrag :show-close="false" :visible.sync="addProp"  width="550px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{propFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
                    </div>     
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('0708', '属性名称') }}</div>
                        <el-input  type="text"   v-model="cname" style="width:350px;"></el-input>
                    </div>
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('0327', '排序') }}</div>
                        <el-input  type="text"   v-model="sortby" style="width:350px;"></el-input>
                    </div>
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('0042', '手动输入') }}</div>
                        <el-checkbox  false-label="N" true-label="Y" v-model="ishand"  ></el-checkbox>
                    </div>
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('1946', '启用') }}</div>
                        <el-checkbox  false-label="N" true-label="Y" v-model="stfg"  ></el-checkbox>
                    </div>
                    <div style="line-height:40px;margin-bottom:10px;color:#606266">{{ $LANG('2110', '说明：手动输入---表示增加的属性，其属性值不是从下拉框中选择,而是动输入') }}</div>
                    <div slot="footer">
                        <el-button type="text" style="margin-right:40px;" icon="iconfont icon-shanchu" @click="addProp=false">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="text" style="margin-right:15px;" icon="iconfont icon-baocun" @click="paramSave"  >{{ $LANG('1638', '确定') }}</el-button>
                    </div>
                </el-dialog>
                <!-- 属性规格管理 -->
                <el-dialog v-dialogDrag :show-close="false" :visible.sync="specModel"  width="810px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;color:white">{{ $LANG('0708', '属性名称') }}：{{specForm.PROPNM}}</span>
                    <el-button @click="addSpec()" type="text" size="small" icon="iconfont icon-xinzeng" style="margin-right:20px;float:right;color:white;font-size:14px;white-space:nowrap;"> {{ $LANG('1262', '新增属性规格') }}</el-button>
                    </div> 
                    <el-table  :data="specData" 
                        border                            
                        size="small"
                        :height="420" 
                        class="custom-table-border"
                        :cell-style="{padding:'2px'}"
                        highlight-current-row
                        style="overflow:auto;margin-top:1px;"> 
                            <el-table-column 
                                prop="CNAME"
                            :label="$LANG('0933', '规格名称')"
                                show-overflow-tooltip
                                align="center"                                  
                                sortable
                                width="500">
                            </el-table-column> 
                            <el-table-column  
                                prop="SORTBY"
                            :label="$LANG('0327', '排序')"
                                align="center"                                  
                                sortable
                                width="100">
                            </el-table-column> 
                        <el-table-column
                            fixed="right"
                        :label="$LANG('0330', '操作')"
                            align="center"
                            width="180">
                            <template slot-scope="scope">
                                <el-button size="small" style="margin-right:10px;"  type="text" icon="iconfont icon-bianji" @click="modSpec(scope.row,scope.$index)">{{ $LANG('1639', '编辑') }}</el-button>
                                <el-button size="small"   type="text" icon="iconfont icon-shanchu" @click="delSpec(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                            </template>
                        </el-table-column>                       
                    </el-table>
                    <div slot="footer">
                        <span style="color:#2db7f5;font-size:12px;margin-left:10px;float:left">{{ $LANG('0834', '共') }} {{specForm.COUNT}} {{ $LANG('0479', '条记录') }} </span>
                        <el-button type="text" style="margin-right:30px;"  icon="iconfont icon-shanchu" @click="specModel=false">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="text" style="margin-right:10px;" icon="iconfont icon-baocun" @click="specSave">{{ $LANG('0130', '保存') }}</el-button>
                    </div>
                </el-dialog>
                <el-dialog v-dialogDrag :show-close="false" :visible.sync="specWin"  width="500px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;color:white">{{specFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
                    </div> 
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('0933', '规格名称') }}</div>
                        <el-input  type="text"   v-model="specVal" style="width:300px;"></el-input>
                    </div>
                    <div style="margin-bottom:20px;display:flex">
                        <div style="font-size:14px;color:#409EFF;margin-right:6px;width:120px">{{ $LANG('0327', '排序') }}</div>
                        <el-input  type="text"   v-model="specSort" style="width:300px;"></el-input>
                    </div>
                    <div slot="footer">
                        <el-button type="text" style="margin-right:30px" icon="iconfont icon-shanchu" @click="specWin=false">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="text" style="margin-right:10px" icon="iconfont icon-baocun" @click="spvalSave">{{ $LANG('0130', '保存') }}</el-button>
                    </div>
                </el-dialog>
                <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
                    </div>
                    <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
                </el-dialog>
                <el-dialog v-dialogDrag :visible.sync="typeWin" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1278', '样板类别设置') }}</span>
                    </div>
                    <prodType @child-close="freshTree"></prodType>
                </el-dialog>
                <el-dialog v-dialogDrag :visible.sync="typeSel" width="760px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1279', '样板类别选择') }}</span>
                    </div>
                    <prodTypeSel @child-select="selectTree"></prodTypeSel>
                </el-dialog>
                    <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
            <!-- 类别变更管理 -->
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="tyWin"  width="500px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:35px;height:35px;font-size:16px;padding-left:5px;color:white">{{ $LANG('0648', '变更类别') }} </span>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0904', '类别属性') }}<span style="color:red">*</span></div>
                    <el-select v-model="v_prop" :placeholder="$LANG('1664', '请选择')" @change="propChg"  style="width:100%">
                       <el-option :label="$LANG('0424', '产成品')" value="PRD"></el-option>
                       <el-option :label="$LANG('0443', '原材料')" value="MAT"></el-option>
                    </el-select>
                </div> 
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex;margin-top:20px">
                    <div style="font-size:12px;width:100px">{{ $LANG('0923', '节点名称') }}<span style="color:red">*</span></div>
 
                    <el-select  @focus="showFlag=true"  v-model="v_node" :placeholder="$LANG('1664', '请选择')" style="width:100%" ref="refTree" >
                        <el-option  :value="v_id" :label="v_id" style="height:auto" hidden />
                        <el-input   :placeholder="$LANG('1779', '请输入关键字进行过滤')" v-model="nodeText" size="medium"  ></el-input>
                        <el-tree :data="nodeData" v-show="showFlag"
                                    :props="defaultProps" 
                                    node-key="id"    
                                    default-expand-all
                                    :style="{background:'#fff',overflow:'auto',height:'400'}"
                                    @node-click ="nodeClick" 
                                    highlight-current
                                    :filter-node-method="filterNode"
                                    :expand-on-click-node="false"
                                    ref="refnode">
                            <template v-slot="{node,data}">                                     
                                <span v-if="data.id ==0 "  >
                                    <span  style="color:#F56C6C;font-size:14px;"><i class="iconfont icon-_shujuzidian" style="color:#F56C6C;font-size:18px;"></i> {{ node.label}} </span>
                                </span>                  
                                <span v-else  > 
                                    <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i>{{ node.label}} </span>
                                </span>
                            </template>
                        </el-tree>  
                        
                    </el-select>
                </div> 
                <div slot="footer">
                    <el-button type="info" size="small" style="margin-right:30px;"  icon="iconfont icon-shanchu" @click="tyWin=false">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun" @click="btnSave">{{ $LANG('0130', '保存') }}</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
            <!-- 字段设置 -->
            <el-dialog class="pub_dialog" v-dialogDrag  v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
                </div>
                <easy-win v-bind:colArr ="fldArr" @child-exit="setWin=false" @child-sure="setOk"></easy-win>
            </el-dialog>
        </div>
        </template>
    </split-pane> 
</template>
<script>
import prodTypeSel from '../datamgt/smptype_sel.vue' 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate } from '../../api/Select' 
import prodType from '../datamgt/smptype.vue'
import FileSaver from 'file-saver'
import easyWin from '../datamgt/easy_field.vue'
//局部注册
export default {
    name:"prd_smplib",
    data () {
        return {
            v_tabName:'first',
            tyWin:false,
            showFlag:true,
            v_id:'',
            v_node:'',
            v_prop:'PRD',
            typeWin:false,
            typeSel:false,
            prevFlag:false,
            nextFlag:false,
            crcyArr:[],
            nodeLabel:this.$LANG('0124', '样板类别'),
            treeid:'0',  
            filterText:'',  
            nodeText:'',
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                label: 'label'
            },
            ishand:'',
            cname:'',
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            stfg:'',
            sortby:'',
            drawer:false,
            addProp:false,
            propFlag:'create',
            upFile:{},
            contRow:{},
            showViewer:false,
            Accept: "png,jpg,jpeg", //上传文件格式限制
            acceptPdf:"pdf",
            saveFlag:false,
            promtWin:false,
            prompt:'',
            stfgCss:'',
            active:'first',
            perWin:false,
            stfgColor:'',
            ordData:[],
            poData:[],
            poArr:[],
            matRow:{},
            listurl:'',//放大的图片
 
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            treeData: [],
            nodeData:[],
            loadingtree:false, 
            listIndex:'-1',
            ordArr:[],
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
 
       
            tabArr:[], //表列
            paramArr:[], //属性数组
            input_hold:this.$LANG('1718', '请输入查询的值'),
            paramRow:{},
            imgData:[],
            mgtModel:false,
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            loadWin:false,
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            propData:[],
            notNull:[],
            uploadData:{}, //上传数据
            pageIndex:1,
            clntArr:[],
            specForm:{
                PROPNM:'',
                COUNT:0,
                CNT:0,
            },
            paramIndex:'',
            paramIdseq:'',
            paramLstseq:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [50,500,1000],
            pageSize: 50,
            vueCol:[],
            specModel:false, //规格窗
            specIdseq:'', //规格主键
            specLstseq:'',//规格主键
            specData:[], //规格集合
            specWin:false,
            specFlag:'create',
            specVal:'',
            specSort:'',
            specIndex:'',
            fileName:'',
            v_index:'',
            v_row:{},
 
            videoFlag:false,
            videoUploadPercent:0,
            delImg:[],
            delPdf:'',
            operArr:[],
            setWin:false,
            fldArr:[],
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            footerData:[],
            v_action:'',
        }
    },
    mounted () { 
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_clnt',' order by cltype').then(res=>{
            this.clntArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16218','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','PARENTNO','4237','','','v_sys_base','').then(res=>{
            this.crcyArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','16218','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promtWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16218','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        scrollerHeight: function() {
            return (window.innerHeight - 125) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        }, 
    },
    components: {
        prodType,  //样板类别
        prodTypeSel,//样板类别选择
        easyWin,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#loading-mat"),
                name: "wave",
            })
            //查询数据
            this.queryEvent('N')
            this.getTabField() //表列字段
            this.getData()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        },
        nodeText(val) {
            this.$refs.refnode.filter(val);
        }
    },
    methods: {
        enterDown(event){
            if (event.keyCode==13){
                this.queryEvent('N')
            }
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.vueCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        dropSel(val){
            if (val =='expdata'){ //导出数据
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'16218',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'样板'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0342', '样板')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
 
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','16218-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'16218-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            } 
        },
        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','16218-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tableRef"].showColumnsByKeys(v_arr)
                    this.$refs["tableRef"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
        setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'16218-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promtWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        itemClick(val){
            this.v_tabName =val     
        },
        prcChg(key){
            if (key=='POPRC'||key=='PONOPRC'||key=='TAXNUM'){
                var v_rate=''
                if (this.matRow['TAXNUM']){
                    this.comboArr['TAXNUM'].some(item=>{
                        if (item.CODE==this.matRow['TAXNUM']){
                            v_rate =item['SUBNO']
                        }
                    })
                }
                if (key=='POPRC' && this.matRow['POPRC'] && v_rate!==''){
                    this.matRow['PONOPRC'] =(Number(this.matRow['POPRC'])/(100+Number(v_rate))*100).toFixed(4)
                }else if (key=='PONOPRC' &&  this.matRow['PONOPRC'] && v_rate!==''){
                    this.matRow['POPRC'] =(Number(this.matRow['PONOPRC'])*(100+Number(v_rate))/100).toFixed(4)
                }else if (key=='TAXNUM' ){
                    if ( this.matRow['POPRC']){
                        this.matRow['PONOPRC'] =(Number(this.matRow['POPRC'])/(100+Number(v_rate))*100).toFixed(4)
                    }else{
                        this.matRow['POPRC'] =(Number(this.matRow['PONOPRC'])*(100+Number(v_rate))/100).toFixed(4)
                    }
                }
            }
        },
        //删除记录
        delRec(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'matno',p_value:row.IDNO ,p_table:'v_orditm'},
                }).then(res=>{  
                    if (res.result.length===0){
                        //先删除明细
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'mat_spec'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                               this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_mat'},
                                }).then(res=>{   
                                    if (res.code!=='200') {
                                        this.promtWin=true
                                        this.prompt=res.result
                                    }else{
                                        this.tabData.splice(index,1)
                                    }
                                })
                            }else{
                                this.promtWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.promtWin=true
                        this.prompt=this.$LANG('1859', '已被销售订单引用,不能删除')
                    }
                })      
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //上行、下行记录
        prevRec(){
            this.rowIndex--
            this.nextFlag=false
            if (this.rowIndex<0){
                this.rowIndex=0
                this.prevFlag=true
            }
            this.rowClick(this.tabData[this.rowIndex])
        },
        nextRec(){
            this.rowIndex++
            this.prevFlag=false
            if (this.rowIndex>this.tabData.length){
                this.rowIndex=this.tabData.length
                this.nextFlag=true
            }
            this.rowClick(this.tabData[this.rowIndex])
        },
        //类别维护
        freshTree(){
            this.getData()
        },
        //类别选择
        matChoose(){
            this.typeSel=true
        },
        selectTree(id,val){
            this.typeSel=false
            this.matRow['MATTY']=id
            this.matRow['MATTYNM']=val
            this.paramRow={}              
            //产品参数   
            this.getProdParam(id)
            this.saveFlag=false
        },
        typeSet(){
            this.typeWin =true
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1
        },
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
   
        handleMaxPdf (file) {
            this.prompt =file.name + this.$LANG('1561', '文件太大， 不能超出') + '10M'
            this.promtWin=true
        },
        handlePdfError (file) {
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择 PDF文件')
            this.promtWin=true
        },
 
        btnSave(){
            if (this.v_node){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'MATNO',p_value:this.v_row['IDNO'],p_key2:'corpid',p_value2:this.v_corpid,p_table:'V_PO_ORDDTL'},
                }).then(res=>{
                    if (res.result.length>0){
                        this.promtWin =true
                        this.prompt =this.$LANG('1904', '此编码已被采购订单引用，不能变更')
                    }else{
                        let v_pre =this.v_prop=='PRD'?'s':'m'
                        let v_cond =' set modelno=\''+this.v_prop +'\',matty=\''+this.v_id+'\',idno=replace(idno,\'S\',\''+ v_pre+'\')'
                        this.$confirm(this.$LANG('1636', '你确定要变更属性吗，确定后此样办编码将不会在此界面显示了'),this.$LANG('1442', '提示'),{
                            confirmButtonText: this.$LANG('1638', '确定'),
                            cancelButtonText:this.$LANG('0132', '取消'),
                            customClass:'messageBox',
                            showClose:false,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type:'info',
                        }).then((res)=>{
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'idseq',p_value:this.v_row['IDSEQ'],p_table:'BS_mat',p_cond:v_cond },
                            }).then(res=>{ 
                                if (res.code=='200') {
                                    this.tyWin =false
                                    this.tabData.splice(this.v_index,1)
                                }else{
                                    this.promtWin =true
                                    this.prompt =res.result
                                }
                            })
                        }).catch(err=>{})
                    }
                })
            }else{
                this.promtWin =true
                this.prompt =this.$LANG('0923', '节点名称')+this.$LANG('2051', '不能为空')
            }
        },
        //规格值保存到数据库
        specSave(){
            this.specModel=false
            //类别属性 排序、名称、启用与否 编辑保存
            this.$axios({   
                method: 'post',
                url:'xuper_auth/propDtlSave',
                data: {p_json:JSON.stringify(this.specData), p_table:'PRD_PROPDTL',p_idseq:this.specIdseq,p_lstseq:this.specLstseq},
            }).then(res=>{ 
                if (res.result==='OK'){
                    //对参数数组重新查询
                    this.getProdParam(this.specIdseq)
                }
            })
        },
        //新增规格
        addSpec(){
            this.specWin =true
            this.specVal  =''
            this.specSort =''
            this.specFlag ='create'
        },
        formatAttachmentLimit(limit){
            const messages ={
                CN:`最多上传${limit}个附件（PDF格式）`,
                EN:`Upload up to ${limit} attachments (PDF format)`,
                YN:`Tải lên tối đa ${limit} tệp đính kèm (định dạng PDF)`,
            }
            return messages[this.$store.state.lang] || messages.CN
        },
        deleteSpecConfirmMessage(){
            const messages ={
                CN:'你确定要删除该参数值？删除后对应的产品属性规格值将被清空',
                EN:'Are you sure you want to delete this parameter value? The corresponding product attribute specification value will be cleared.',
                YN:'Bạn có chắc chắn muốn xóa giá trị tham số này không? Giá trị quy cách thuộc tính sản phẩm tương ứng sẽ bị xóa.',
            }
            return messages[this.$store.state.lang] || messages.CN
        },
        delSpec(row,index){
            this.$confirm(this.deleteSpecConfirmMessage(),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if(row.IDSEQ ) {//+":"+row.LSTSEQ+':'+row.ITMSEQ)
                //发起删除请求
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_key3:'ITMSEQ',p_value3:row.ITMSEQ,p_table:'PRD_PROPDTL'},
                    }).then(res=>{      
                        if(res.code =='200')  {  
                            this.specData.splice(index,1)         
                        }else{
                            this.prompt=res.message
                            this.promtWin=true
                        }        
                    }) 
                }else{
                    this.specData.splice(index,1) 
                }           
            }).catch(()=>{})
        },
        //编辑规格
        modSpec(row,index){
            this.specWin =true
            this.specVal =row.CNAME
            this.specSort =row.SORTBY
            this.specIndex =index
            this.specFlag='edit'
        },
        //规格值暂存到数组中
        spvalSave(){
            if(!this.specVal){
                this.prompt=this.$LANG('0933', '规格名称')+this.$LANG('2051', '不能为空')
                this.promtWin=true
            }else{
                let obj={CNAME:this.specVal,SORTBY:this.specSort,CORPID:this.v_corpid }
 
                if (this.specFlag ==='edit'){
                    this.specData.splice(this.specIndex,1,obj)
                }else{
                    this.specData.splice(this.specData.length,0,obj) 
                }
                this.specWin =false
            }
        },
        //新增属性名称
        addParam(){
            this.addProp=true
            this.stfg='Y'
            this.cname=''
            this.ishand=''
            this.sortby=''
        },
        //编辑属性名称
        modRec(row,index){
            this.addProp=true
            this.propFlag='edit'
            this.stfg=row.STFG
            this.cname=row.CNAME
            this.ishand=row.ISHAND
            this.sortby=row.SORTBY
            this.paramIndex =index
            this.paramIdseq=row.IDSEQ
            this.paramLstseq=row.LSTSEQ
        },
        //管理属性规格值
        mgtRec(row){
            if (row.LSTSEQ){
                this.specForm.PROPNM=row.CNAME
                this.specModel=true
                this.specIdseq =row.IDSEQ
                this.specLstseq=row.LSTSEQ
                getBaseData('xuper_auth/getBaseData','IDSEQ',row.IDSEQ,'LSTSEQ',row.LSTSEQ,'V_PRD_PROPDTL').then((res)=>{               
                        this.specData =res.result
                        this.specForm.COUNT=res.result.length
                }); 
            }else{
                this.prompt=this.$LANG('1915', '属性名称未保存时不能去管理属性下的值')
                this.promtWin=true
            }
        },
        mgtSave(){
            this.mgtModel=false
            //类别属性 排序、名称、启用与否 编辑保存
            this.$axios({   
                method: 'post',
                url:'xuper_auth/matPropSave',
                data: {p_json:JSON.stringify(this.propData), p_table:'PRD_PROP',p_idseq:this.matRow['MATTY']},
            }).then(res=>{ 
                if (res.result==='OK'){
                    //对参数数组重新查询
                    this.getProdParam(this.matRow['MATTY'])
                }
            })
        },
        paramSave(){
            if(!this.cname){
                this.prompt=this.$LANG('0708', '属性名称')+this.$LANG('2051', '不能为空')
                this.promtWin=true
            }else{
                let obj={CNAME:this.cname,ISHAND:this.ishand,STFG:this.stfg,SORTBY:this.sortby,CORPID:this.v_corpid,IDSEQ:this.paramIdseq,LSTSEQ:this.paramLstseq}
                if (this.propFlag ==='edit'){
                    this.propData.splice(this.paramIndex,1,obj)
                }else{
                    this.propData.splice(this.propData.length,0,obj) 
                }
                this.addProp =false
            }
        },
        //管理类别属性
        mgtParam(){
            if (!this.matRow['MATTY']){
                this.promtWin=true
                this.prompt=this.$LANG('1734', '请选择样板类别')
            }else{
                this.mgtModel =true
                let matty_=this.matRow['MATTY']
                getBaseData('xuper_auth/getBaseData','IDSEQ',matty_,'corpid',this.v_corpid,'V_PRD_PROP').then((res)=>{               
                    this.propData =res.result
                    this.specForm.CNT =res.result.length
                }); 
            }
        },
        //节点点击
        handleNodeClick(data ){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.queryEvent('N')
        },
        //节点点击
        nodeClick(data ){
            var that =this
            this.v_id =data.id
            this.showFlag =false
            this.nodeText =''
            this.v_node =data.label
            that.$refs['refTree'].blur()   
        },
        //重新刷新产品属性和 属性值
        getProdParam(idseq){
            //产品参数   
            let cond_=' and (idseq='+idseq+' or idseq=(select parentno from bs_type where code=\''+idseq+'\')) order by sortby,lstseq'
            this.$axios({
                method: 'post',
                url:'xuper_auth/getPrdSpec',
                data: {p_key:'corpid',p_value:this.v_corpid, p_key2:'STFG',p_value2:'Y',p_cond:cond_,p_table:'V_PRD_PROP'},
            }).then(res=>{      
                this.paramArr =res.result 
            }) 
        },
        modelChange(){
            this.$forceUpdate()
        },
 
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promtWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择 jpg or png')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promtWin =true
            this.prompt=file.name + this.$LANG('1561', '文件太大， 不能超出') + '2M'
        },
 
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
 
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:this.v_action,PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile ( file,v_code) {
            this.v_action =v_code
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
            //产品参数   
            this.paramArr=[]
            
            //从规 格中取当取产品的属性
            this.$axios({
                method: 'post',
                url:'xuper_auth/getPrdSpec',
                data: {p_key:'matidseq',p_value:row.IDSEQ,p_cond:' order by sortby ',p_table:'V_MAT_SPEC_PROP'},
            }).then(res=>{  
                this.getProdParam(row.MATTY) //来自于产品属性库
            }) 
            //行赋值    
            this.matRow =JSON.parse(JSON.stringify(row))  //深拷贝
   
            //产品参数值 selSpecValue
            this.paramRow={}
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'mat_spec'},
            }).then(res=>{  
                for (let k=0;k<res.result.length;k++){   
                    this.paramRow[res.result[k]['REFLSTSEQ']] =res.result[k]['CODE']       
                }
            })

            
        },
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
       
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16218',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.matRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promtWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={} ,vm=this 
                let propseq=vm.matRow['MATTY']
                Object.assign(obj_,vm.matRow,{ 'CORPID':this.v_corpid,'MODELNO':'SMP' }) 
                this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_mat',frmid:'16218'},
                }).then(res=>{      
                    if(res.result ==='OK')  {                                 
                        //2、参数、参数值保存
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/matSpecSave',
                            data: {p_json:JSON.stringify(vm.paramRow), p_table:'MAT_SPEC',p_idseq:res.idseq,idty:propseq},
                        }).then(res=>{
                            if (res.code=='200'){
                                this.queryEvent('N')
                                this.drawer =false
                            }else{
                                if (res.result.indexOf('ORA-00001')){
                                   this.prompt =this.$LANG('1916', '已存在相同产品类别属性的编码，请核查')
                                    this.promtWin=true   
                                }else{
                                    this.prompt =res.result
                                    this.promtWin=true  
                                }
                            }
                        })
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:res.idseq},
                            })
                        }  
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        //删除Pdf 文件
                        if (this.delPdf!==''){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/deleteFile',
                                data: {p_value:this.delPdf},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promtWin=true
                                }        
                            })  
                        }      
                        this.delImg=[]
                        this.delPdf=''        
                    }else{
                        this.prompt =res.result
                        this.promtWin=true
                    }        
                }) 
            }
 
        },
 
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('0134', '审核'):val==='N'?this.$LANG('0137', '弃审'):this.$LANG('0257', '作废')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (val=='X' &&( row['REFORDNO'] ) ){
                    this.promtWin =true
                    this.prompt =this.$LANG('1903', '此物料有关联到销售订单，不能作废')
                }else{
                    var vm=this;
                    let cond_=' set stfg=\''+val+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full') +'\''
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_mat',p_cond:cond_ },
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.queryEvent('N')
                        }else{
                            this.promtWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }).catch(()=>{})
        },
        //产品明细
        getMatList(cond){
            this.loadingInstance.show() 
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'SMP',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam +' desc',p_table:'V_BS_mat_SMP'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.loadingInstance.close() 
                        //this.getFootSum()
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.loadingInstance.close() 
                }               
            }) 
        },
        getFootSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.tabData.reduce((prev,cur)=>{
                let v_qty =cur.STKQTY ||0 
                return Number(prev) + Number(v_qty) 
            },0)
            this.footerData =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    STKQTY: v_ttlqty.toLocaleString(),
                },
            ]
        } , 
        rowShow(){
            this.v_row = {}
            this.v_inputrow = {}
            this.pageIndex =1
            this.queryEvent('N')
        } ,
        //产品订单明细
        getOrdList(matno){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:matno,p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_orditm'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.ordData=res.result
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }) 
        },
        //采购订单明细
        getPoList(matno){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:matno,p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_smp_podtl'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.poData=res.result
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }) 
        },
 
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allData.slice(_start,_end)
            //this.getFootSum()
        },
        propChg(){
            this.getNode(this.v_prop)
        },
        //类别变更
        nodeRec(row,index){
            this.tyWin =true
            this.v_row =row
            this.v_index =index
            this.getNode(this.v_prop)
        },
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='N'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.matRow =JSON.parse(JSON.stringify(row))
            this.drawer=true 
            this.rowIndex=index   
            //产品图片
            this.qryImgData(row.IDSEQ)  
            //销售订单
            this.getOrdList(row.IDNO)
            //采购订单
            this.getPoList(row.IDNO)   
        },
        getRowKey(row){
            return row.IDSEQ
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        inputQry(){
            this.pageIndex =1
            this.queryEvent('N')
        },
        //新增 
        addRec(){ 
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.matRow={'IDSEQ':'',STFG:'N'}      
            this.paramArr=[]  
            this.imgData=[] 
      
            this.saveFlag=false
            if (this.treeid !=='0'){
                this.matRow['MATTY']=this.treeid
                this.matRow['MATTYNM']=this.nodeLabel
                this.paramRow={}              
                //物料参数   
                this.getProdParam(this.treeid) 
            }
        },
 
        //左边菜单
        getData() {  
            var vm=this;
            this.loadingtree=true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData' ,
                data: {p_table:'v_SMP_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\' and ty=\'SMP\'' }
            }).then(function(res){                  
                vm.treeData =res.result   
                if(res.result.length > 0 ){
                    vm.$nextTick(() =>{
                        //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                }  
                vm.loadingtree =false           
            })                              
        },
        getNode(v_type) {  
            var vm=this ,v_table = v_type=='PRD' ?'v_BS_TYPE':'v_mat_TYPE'
            this.nodeData =[]
            this.v_node =''
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData' ,
                data: {p_table:v_table,p_cond:' and corpid=\''+this.v_corpid+'\'' }
            }).then(function(res){                  
                vm.nodeData =res.result        
            })                               
        },
        queryEvent(v_where){
            let v_cond ='' , v_oper='' ,v_edcss='' ,cond_=''
            if (this.selparam){ //列1
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            if(this.treeid!=='0'){
                cond_= cond_+ ' and (matty in (select code from bs_type where parentno=\''+this.treeid+'\') or Matty=\''+this.treeid+'\')  and stfg!=\'X\'' 
            } 
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and upper('+item+')  like  upper(\'%'+ (this.v_row[item]).trim()+'%\')'
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''  
                        }
                    }
                }
            })
            if (v_where =='N'){
                this.getMatList(cond_+v_cond)
            }
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            this.vueCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16218','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.vueCol =[]
                this.tabArr =[]
                const mainFields =res.result
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        sortable:rowField.SORTABLE,
                        edcss:rowField.EDCSS,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        disabled:rowField.DISABLED,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: itcol.title,
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            edcss: itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='number') {
                                    return (
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                            </div>
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option value="=">=</option>
                                                    <option value=">">&gt;</option>
                                                    <option value="<">&lt;</option>
                                                    <option value="!=">!=</option>
                                                </select>
                                                <el-input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>
                                    )
                                }else{
                                    if (itcol.EDCSS=='checkbox'){
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]} on-change={()=>{this.inputQry()}}>
                                                        <el-option value="Y" label="是"></el-option>
                                                        <el-option value="N" label="否"></el-option>
                                                    </el-select>
                                                </div>
                                            </div>
                                        )
                                    }else {
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1952', '有效')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('1951', '无效')}</el-tag> )
                                    }  
                                        
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                        if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                        }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                        }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:205,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ( 
                            <div>
                                <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.addBool} on-click={()=>{this.nodeRec(row,rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0279', '变更')}</span></el-link>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.cancelBool} on-click={()=>{this.recSet(row,'X' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
 
                            </div>                                
                        )
    
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.getSetList()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16218','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16218','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .item-width{
        width:32%;
        height: 20px !important;
    }
    .oneMenu{
        height:30px;
        line-height:30px;
        background:white;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    
    .active { 
        border-bottom:3px solid #cc0000;
        color:#389;
    } 
 
</style>
<style lang="less">
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
        height:20px !important;
    }
</style>
